const _infoapp = { // data e versione aggiornata ma no pubblicata
	Title: 'Guida Pratica Lavoro',
	name: 'Guida Pratica Lavoro',
	shortname: 'G.P.L.',
	// La build 2.2.1 aggiorno solo lo script; dalla 2.2.2 mantenere allineate versione applicativa e immagine.
	version: '2.2.5',
	releaseType: 'stable',
	datebuild: '13/08/2026',
	imgLogo: '/images/home_icone/Cerchio_redigo_Intestazione.png',
	setLogo: (logo: string) => {
		_infoapp.imgLogo = logo
	}
	/* getDarkLightLogo: () => {
		console.log('AppConfig.ts: getDarkLightLogo: useLayout().isDarkTheme.value: ', useLayout().isDarkTheme.value)

		if (useLayout().isDarkTheme.value) {
			return _infoapp.imgLogo.replace('dark', 'light')
		} else {
			return _infoapp.imgLogo.replace('light', 'dark')
		}
	} */
}

export const appConfig = {
	// return {
	infoapp: _infoapp,
	inDevelopment: process.env.NODE_ENV !== 'production'

} as const

/**
  name -        alias
Apprendistato - app
Divisore - div
Malattia-Maternità-Infortunio - mmi
Permessi - per
Preavviso - pre
Prova - prova
Retribuzione aggiuntiva - ra
Retribuzione Base - rb
Straordinario-Maggiorazione-Indennità - smi
Territoriale - ter

[
	{ label: 'CCNL', icon: 'pi pi-home', component: resolveComponent('CcnlDett'), active: true, value: 0 },
	{ label: 'Minimi', icon: 'pi pi-calculator', component: resolveComponent('RetribBase'), active: false, value: 1 },
	{ label: 'Apprendistato', icon: 'pi pi-chart-line', component: resolveComponent('ApprendistatoRetribBase'), value: 2 },
	{ label: 'Altre Retrib.', icon: 'pi pi-plus', component: resolveComponent('RetribAggiuntiva'), value: 3 },
	{ label: 'Str. Mag. Ind.', icon: 'pi pi-users', component: resolveComponent('RetribSMI'), value: 4 },
	{ label: 'Territoriali', icon: 'pi pi-map-marker', component: resolveComponent('RetribLocali'), value: 5 },
	{ label: 'Preavviso', icon: 'pi pi-stopwatch', component: resolveComponent('Preavviso'), value: 6 },
	{ label: 'Permessi', icon: 'pi pi-calendar-times', component: resolveComponent('CcnlPermessi'), value: 7 },
	{ label: 'Mal. Mat. Inf.', icon: 'pi pi-heart', component: resolveComponent('CcnlEventi'), value: 8 },
	{ label: 'Prova', icon: 'pi pi-compass', component: resolveComponent('ccnlProva'), value: 9 },
	{ label: 'Divisori', icon: 'pi pi-clock', component: resolveComponent('ccnlDivisori'), value: 10 }

	]
 */

export const msgNoDataTable = 'In fase di elaborazione redazionale'

/**
 * ICON MAPPING v4.0 - Material Design Icons (MDI)
 * Mappa delle icone specifiche per ogni sezione CCNL
 * Pattern: mdi:[nome-icona]
 */
export const ccnlSectionIcons = {
	dettccnl: 'mdi:information-outline',           // CCNL - Dettagli informativi
	app: 'mdi:account-school',                     // Apprendistato
	div: 'mdi:view-list',                          // Divisori (orario lavoro)
	mmi: 'mdi:calendar-alert',                     // Malattia-Maternità-Infortunio (eventi)
	per: 'mdi:calendar-check',                     // Permessi
	pre: 'mdi:bell-alert-outline',                 // Preavviso
	prova: 'mdi:clipboard-check-outline',          // Prova
	ra: 'mdi:cash-multiple',                       // Retribuzione Aggiuntiva
	rb: 'mdi:currency-eur',                        // Retribuzione Base (minimi)
	smi: 'mdi:cash-plus',                          // Straordinario-Maggiorazione-Indennità
	ter: 'mdi:map-marker-multiple',                // Territoriale (retrib locali)
	// Icone utility comuni
	timeline: 'mdi:timeline-clock',                // Valenze temporali
	print: 'mdi:printer-outline',                  // Stampa PDF
	suspend: 'mdi:pause-circle',                   // Sospensione valenza
	active: 'mdi:play-circle'                      // Valenza attiva
} as const

export type CcnlSectionIconKey = keyof typeof ccnlSectionIcons

/**
 * Helper function per ottenere l'icona di una sezione
 * @param alias - Alias della sezione (es. 'rb', 'per', 'app')
 * @returns Nome icona MDI completo (es. 'mdi:currency-eur')
 */
export const getCcnlSectionIcon = (alias: tAliasSection | string): string => {
	return ccnlSectionIcons[alias as CcnlSectionIconKey] || 'mdi:file-document-outline'
}

export type iNameAliasSection = {
	name: string
	alias: string
	label: string
	icon: string
	component: string
	active?: boolean
	value: number
	items?: iNameAliasSection[],
	badge?: number,
	menuVisible?: boolean
}
const listNameAliasSection: iNameAliasSection[] =
	[
		/* { name: 'CcnlDett', alias: 'dettccnl', label: 'CCNL', icon: 'pi pi-home', component: 'CcnlDett', active: true, value: 0 },
	  { name: 'Apprendistato', alias: 'app', label: 'Apprendistato', icon: 'pi pi-chart-line', component: 'ApprendistatoRetribBase', value: 2 },
	  { name: 'Divisore', alias: 'div', label: 'Divisori', icon: 'pi pi-clock', component: 'ccnlDivisori', value: 10 },
	  { name: 'Malattia-Maternità-Infortunio', alias: 'mmi', label: 'Mal. Mat. Inf.', icon: 'pi pi-heart', component: 'CcnlEventi', value: 8 },
	  { name: 'Permessi', alias: 'per', label: 'Giustificativi', icon: 'pi pi-calendar-times', component: 'CcnlPermessi', value: 7 },
	  { name: 'Preavviso', alias: 'pre', label: 'Preavviso', icon: 'pi pi-stopwatch', component: 'Preavviso', value: 6 },
	  { name: 'Prova', alias: 'prova', label: 'Prova', icon: 'pi pi-compass', component: 'ccnlProva', value: 9 },
	  { name: 'Retribuzione aggiuntiva', alias: 'ra', label: 'Altre Retribuzioni', icon: 'pi pi-list', component: 'RetribAggiuntiva', value: 3 },
	  { name: 'Retribuzione Base', alias: 'rb', label: 'Retribuzioni', icon: 'pi pi-calculator', component: 'RetribBase', active: false, value: 1 },
	  { name: 'Straordinario-Maggiorazione-Indennità', alias: 'smi', label: 'Str. Mag. Ind.', icon: 'pi pi-users', component: 'RetribSMI', value: 4 },
	  { name: 'Territoriale', alias: 'ter', label: 'Territoriali', icon: 'pi pi-map-marker', component: 'RetribLocali', value: 5 } */
		/* PRE Mappa icone aggiornata v4.0 */
		/* { name: 'CcnlDett', alias: 'dettccnl', label: 'CCNL', icon: 'pi pi-home', component: 'CcnlDett', active: true, value: 0, menuVisible: true },
		{ name: 'Apprendistato', alias: 'app', label: 'Apprendistato', icon: 'pi pi-chart-line', component: 'ApprendistatoRetribBase', value: 3, menuVisible: true },
		{ name: 'Divisore', alias: 'div', label: 'Divisori', icon: 'pi pi-clock', component: 'ccnlDivisori', value: 10, menuVisible: false },
		{ name: 'Malattia-Maternità-Infortunio', alias: 'mmi', label: 'Inf. Mal. Mat.', icon: 'pi pi-heart', component: 'CcnlEventi', value: 7, menuVisible: true },
		{ name: 'Permessi', alias: 'per', label: 'Giustificativi', icon: 'pi pi-calendar-times', component: 'CcnlPermessi', value: 6, menuVisible: true },
		{ name: 'Preavviso', alias: 'pre', label: 'Preavviso', icon: 'pi pi-stopwatch', component: 'Preavviso', value: 9, menuVisible: true },
		{ name: 'Prova', alias: 'prova', label: 'Prova', icon: 'pi pi-compass', component: 'ccnlProva', value: 8, menuVisible: true },
		{ name: 'Retribuzione aggiuntiva', alias: 'ra', label: 'Altre Retribuzioni', icon: 'pi pi-list', component: 'RetribAggiuntiva', value: 2, menuVisible: true },
		{ name: 'Retribuzione Base', alias: 'rb', label: 'Retribuzioni', icon: 'pi pi-calculator', component: 'RetribBase', active: false, value: 1, menuVisible: true },
		{ name: 'Straordinario-Maggiorazione-Indennità', alias: 'smi', label: 'Ind. Mag. Str.', icon: 'pi pi-users', component: 'RetribSMI', value: 4, menuVisible: true },
		{ name: 'Territoriale', alias: 'ter', label: 'Territoriali', icon: 'pi pi-map-marker', component: 'RetribLocali', value: 5, menuVisible: true } */
		/* POST Mappa icone aggiornata v4.0 */
		{ name: 'CcnlDett', alias: 'dettccnl', label: 'CCNL', icon: getCcnlSectionIcon('dettccnl'), component: 'CcnlDett', active: true, value: 0, menuVisible: true },
		{ name: 'Apprendistato', alias: 'app', label: 'Apprendistato', icon: getCcnlSectionIcon('app'), component: 'ApprendistatoRetribBase', value: 3, menuVisible: true },
		{ name: 'Divisore', alias: 'div', label: 'Divisori', icon: getCcnlSectionIcon('div'), component: 'ccnlDivisori', value: 10, menuVisible: false },
		{ name: 'Malattia-Maternità-Infortunio', alias: 'mmi', label: 'Inf. Mal. Mat.', icon: getCcnlSectionIcon('mmi'), component: 'CcnlEventi', value: 7, menuVisible: true },
		{ name: 'Permessi', alias: 'per', label: 'Giustificativi', icon: getCcnlSectionIcon('per'), component: 'CcnlPermessi', value: 6, menuVisible: true },
		{ name: 'Preavviso', alias: 'pre', label: 'Preavviso', icon: getCcnlSectionIcon('pre'), component: 'Preavviso', value: 9, menuVisible: true },
		{ name: 'Prova', alias: 'prova', label: 'Prova', icon: getCcnlSectionIcon('prova'), component: 'ccnlProva', value: 8, menuVisible: true },
		{ name: 'Retribuzione aggiuntiva', alias: 'ra', label: 'Altre Retribuzioni', icon: getCcnlSectionIcon('ra'), component: 'RetribAggiuntiva', value: 2, menuVisible: true },
		{ name: 'Retribuzione Base', alias: 'rb', label: 'Retribuzioni', icon: getCcnlSectionIcon('rb'), component: 'RetribBase', active: false, value: 1, menuVisible: true },
		{ name: 'Straordinario-Maggiorazione-Indennità', alias: 'smi', label: 'Ind. Mag. Str.', icon: getCcnlSectionIcon('smi'), component: 'RetribSMI', value: 4, menuVisible: true },
		{ name: 'Territoriale', alias: 'ter', label: 'Territoriali', icon: getCcnlSectionIcon('ter'), component: 'RetribLocali', value: 5, menuVisible: true }

	]
export const immutableListNameAliasSection = [...listNameAliasSection]
export type tAliasSection = 'app' | 'div' | 'mmi' | 'per' | 'pre' | 'prova' | 'ra' | 'rb' | 'smi' | 'ter'

export const menuDettCcnlCreate = (listNameAliasSectionOverride?: iNameAliasSection[]): iNameAliasSection[] => {
	const _listNameAliasSection = [...listNameAliasSectionOverride || listNameAliasSection]
	// console.log('menuDettCcnlCreate _listNameAliasSection:', _listNameAliasSection)

	const subMenuList: iNameAliasSection[] = _listNameAliasSection.filter(item => item.alias === 'ra' || item.alias === 'ter')
	const menu = {
		label: 'Altre Retrib.',
		icon: 'pi pi-plus',
		badge: subMenuList.length,
		items: subMenuList
	} as iNameAliasSection
	const completeMenu = _listNameAliasSection.filter(item => item.alias !== 'ra' && item.alias !== 'ter' && item.menuVisible).sort((a, b) => a.value - b.value) as iNameAliasSection[]//
	const newIndexMenu = completeMenu.findIndex(item => item.alias === 'rb') + 1
	completeMenu.splice(newIndexMenu, 0, menu)
	return completeMenu
}
export const menuDettCcnl = menuDettCcnlCreate()

export const getlistNameAliasSection = listNameAliasSection.map(item => item).sort((a, b) => a.value - b.value)
export const getAliasSectionFindByName = (name: string) => listNameAliasSection.find(item => item.name === name)
export const getAliasSectionFindByAlias = (alias: string) => listNameAliasSection.find(item => item.alias === alias)
